import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { ReactComponent as Book } from '../../../assets/icons/book.svg'
import { ReactComponent as PieChart } from '../../../assets/icons/pie-chart.svg'
import { ReactComponent as Text } from '../../../assets/icons/text.svg'
import { getConfiguration } from '../../../utils/config'

import { joinClassNames } from '../../../utils/styles'
import styles from './nlu-data-header.module.scss'

function NLUDataHeader() {
    const { t } = useTranslation()
    const { enabledTabs } = getConfiguration()

    return (
        <div className={styles.nluDataHeader__navWrapper}>
            <nav className={styles.nluDataHeader__nav}>
                {enabledTabs.nluData && (
                    <NavLink
                        to="/training-data/data"
                        className={({ isActive }) =>
                            joinClassNames(
                                styles.nluDataHeader__url,
                                isActive && styles.nluDataHeader__urlActive
                            )
                        }
                    >
                        <>
                            <Book className={styles.nluDataHeader__icon} />
                            {t('training_data')}
                        </>
                    </NavLink>
                )}
                {enabledTabs.nluDataLookup && (
                    <NavLink
                        to="/training-data/lookup"
                        className={({ isActive }) =>
                            joinClassNames(
                                styles.nluDataHeader__url,
                                isActive && styles.nluDataHeader__urlActive
                            )
                        }
                    >
                        <>
                            <Text className={styles.nluDataHeader__icon} />
                            {t('regex')}
                        </>
                    </NavLink>
                )}
                {enabledTabs.nluDataStats && (
                    <NavLink
                        to="/training-data/stats"
                        className={({ isActive }) =>
                            joinClassNames(
                                styles.nluDataHeader__url,
                                isActive && styles.nluDataHeader__urlActive
                            )
                        }
                    >
                        <>
                            <PieChart className={styles.nluDataHeader__icon} />
                            {t('statistics')}
                        </>
                    </NavLink>
                )}
            </nav>
        </div>
    )
}

export default NLUDataHeader
